function buildEventFormData(
	data: Partial<MeeEvent>,
	imageFile: File | null,
	imageRemoved: boolean
): FormData {
	const formData = new FormData();
	formData.append("name", data.name ?? "");
	formData.append("location", data.location ?? "");
	formData.append("body", data.body ?? "");
	formData.append("start_date", data.startDate ?? "");
	formData.append("show_start_date", String(data.showStartDate ?? true));
	formData.append("end_date", data.endDate ?? "");
	formData.append("show_end_date", String(data.showEndDate ?? true));

	if (data.tag) {
		formData.append("tag", data.tag);
	} else {
		formData.append("tag", "");
	}

	if (imageFile) {
		formData.append("image", imageFile);
	} else if (imageRemoved) {
		formData.append("image", "");
	}

	return formData;
}

export const adaptCreateEventPayload = (
	data: Partial<MeeEvent>,
	imageFile: File | null
): FormData => {
	return buildEventFormData(data, imageFile, false);
};

export const adaptEditEventPayload = (
	data: Partial<MeeEvent>,
	imageFile: File | null,
	imageRemoved = false
): FormData => {
	return buildEventFormData(data, imageFile, imageRemoved);
};
